import { Box, BoxProps } from "@mui/material";
import { MonitoringCardHeader } from "src/components/cards/custom/monitoring-card/MonitoringCardHeader";
import { ReactNode } from "react";
import { MonitoringCardTopValue } from "src/components/cards/custom/monitoring-card/MonitoringCardTopValue";
import { useScreenSize } from "src/hooks/useScreenSize";
import { SenecCard } from "src/components/cards/base/SenecCard";

export interface SimpleMonitoringCardProps {
    /**
     * Card title
     */
    title: string;

    /**
     * Value to be displayed in the card
     */
    value: string;

    /**
     * Unit of the value
     */
    unit: string;

    /**
     * Indicator if value is still loading
     */
    isLoading: boolean;

    /**
     * Error text to be displayed instead of value
     */
    error?: string;

    /**
     * Card icon to be displayed on left side of title. In mobile view it switches to end of right side.
     */
    contentIcon?: ReactNode;

    /**
     * Info icon to be displayed on end of right side of title. In mobile view it switches to right next to title.
     */
    infoIcon?: ReactNode;
}

export const SimpleMonitoringCard = ({
    title,
    value,
    unit,
    contentIcon,
    infoIcon,
    isLoading,
    error,
}: SimpleMonitoringCardProps) => {
    const { isMobile, isTablet } = useScreenSize();
    const cardContentProps: BoxProps =
        (isMobile || isTablet) && contentIcon
            ? {
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
              }
            : {};

    return (
        <SenecCard>
            <Box display="flex" gap="14px" {...cardContentProps}>
                {contentIcon && (
                    <Box height={24} width={24}>
                        {contentIcon}
                    </Box>
                )}
                <Box flexDirection="column" justifyContent="space-between" overflow="hidden" flex={1}>
                    <MonitoringCardHeader
                        topTitle={title}
                        infoIcon={infoIcon}
                        justifyContent={isMobile || isTablet ? "left" : "space-between"}
                    />
                    <MonitoringCardTopValue
                        topTitle={title}
                        topValue={value}
                        topValueUnit={unit}
                        isLoading={isLoading}
                        error={error}
                    />
                </Box>
            </Box>
        </SenecCard>
    );
};
